import { Appwrite } from 'appwrite';
import React from 'react';
export const AppWriteUrl = 'https://console.streamlux.com/v1';
export const AppWriteProjectId = '605ce39a30c01';


export const AppwriteContext = React.createContext<Appwrite>(undefined as unknown as Appwrite);
